module.exports = __webpack_public_path__ + "static/Arie_new-472a245dc9772a41493c0ccd1f6f2d63.svg";